import React, { useEffect, useRef, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
// import Image1 from "./images/informes.jpg";
// import Image2 from "./images/capacitacion.jpg";
// import Image3 from "./images/image3.jpg";
import { ToastContainer } from "react-toastify";
import { Footer } from "./component/Footer";
import "../public/styles/index.css";
import { Navbar } from "./component/Navar";
import {
    Phone,
    MessageCircle,
    Clock,
    AlertTriangle,
    Info,
    Shield,
    CheckCircle2,
    XCircle,
    ArrowUpCircle,
    Handshake,
    FileCheck,
    ChevronDown,
    Menu,
} from "lucide-react";
// import Snowfall from 'react-snowfall'

const sections = [
    { id: "objetivo", label: "Objetivo" },
    { id: "aceptacion", label: "Aceptación" },
    { id: "canales", label: "Canales Oficiales" },
    { id: "horario", label: "Horario de Atención" },
    { id: "prioridades", label: "Clasificación de Prioridades" },
    { id: "tiempos", label: "Tiempos de Respuesta" },
    { id: "informacion", label: "Información Requerida" },
    { id: "uso-responsable", label: "Uso Responsable" },
    { id: "escalamiento", label: "Escalamiento" },
    { id: "compromiso", label: "Compromiso del Proveedor" },

];

export const PoliticalSupport = () => {
    const [activeSection, setActiveSection] = useState("objetivo");
    const [mobileNavOpen, setMobileNavOpen] = useState(false);
    const sectionRefs = useRef<Record<string, HTMLElement | null>>({});

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                const visible = entries.filter((e) => e.isIntersecting);
                if (visible.length > 0) {
                    const top = visible.reduce((a, b) =>
                        a.boundingClientRect.top < b.boundingClientRect.top ? a : b
                    );
                    setActiveSection(top.target.id);
                }
            },
            {
                rootMargin: "-80px 0px -70% 0px",
                threshold: 0
            }
        );

        sections.forEach(({ id }) => {
            const el = document.getElementById(id);
            if (el) {
                sectionRefs.current[id] = el;
                observer.observe(el);
            }
        });

        return () => observer.disconnect();
    }, []);

    const scrollTo = (id: string) => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
        setMobileNavOpen(false);
    };

    const [showSidebar, setShowSidebar] = useState(false);

    const [sidebarTop, setSidebarTop] = useState(80);

    useEffect(() => {
        const handleScroll = () => {
            const heroHeight = window.innerHeight;
            const footer = document.getElementById("footer");

            if (!footer) return;

            const footerTop = footer.getBoundingClientRect().top;
            const sidebarHeight = 490; // altura aproximada del sidebar
            const topFixed = 100; // altura del navbar

            // Cuando el footer se acerca, empuja el sidebar hacia arriba
            if (footerTop < sidebarHeight + topFixed + 60) {
                setSidebarTop(footerTop - sidebarHeight - 60);
            } else {
                setSidebarTop(topFixed);
            }

            setShowSidebar(window.scrollY > heroHeight - 90);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <>
            <link rel="preconnect" href="https://fonts.googleapis.com" />
            <link rel="preconnect" href="https://fonts.gstatic.com" />
            <link
                href="https://fonts.googleapis.com/css2?family=Aclonica&family=Crimson+Text:ital,wght@0,400;0,600;0,700;1,400;1,600;1,700&family=DynaPuff:wght@400..700&family=Noto+Serif+Telugu:wght@100..900&family=Righteous&family=Rozha+One&display=swap"
                rel="stylesheet"
            />
            {/* <Snowfall color="white" snowflakeCount={200} />
        <Snowfall
          snowflakeCount={200}
          color="#ff0000"   // rojo
        />
        <Snowfall
          snowflakeCount={200}
          color="#00ff00"   // verde
        /> */}


            {/* "Inicio" Section */}
            {/* <motion.div
        id="inicio"
        className="inicio-section"
        initial={{ opacity: 0, x: -100 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.5 }}
      >
        <h2>Bienvenido a Rocky</h2>
        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit...</p>
      </motion.div> */}

            {/* "Servicios" Section */}
            <Navbar />
            <div className="min-vh-100" style={{ paddingTop: "60px" }}>

                <div className="container-xl py-4">
                    <div className="d-flex align-items-start gap-4">

                        {/* Sidebar */}
                        <aside className="d-none d-lg-block flex-shrink-0" style={{ width: "250px", alignSelf: "stretch" }}>
                            <div style={{ width: "250px" }}></div>
                            <div className=" p-3" style={{
                                position: "fixed",
                                top: `${sidebarTop}px`,        // altura de tu navbar azul
                                width: "250px",
                                zIndex: 100,
                                opacity: showSidebar ? 1 : 0,
                                pointerEvents: showSidebar ? "auto" : "none",
                                transition: "opacity 0.3s ease",
                                maxHeight: "calc(100vh - 160px)", // ← no crece más allá de la pantalla
                                overflowY: "auto",
                            }}>
                                <p className="text-uppercase text-muted fw-bold small mb-3">Contenido</p>
                                {sections.map((s) => (
                                    <button
                                        key={s.id}
                                        onClick={() => scrollTo(s.id)}
                                        className={`d-block w-100 text-start px-3 py-2 rounded border-0 small mb-1 ${activeSection === s.id
                                            ? "bg-primary bg-opacity-10 text-primary fw-semibold border-start border-2 border-primary"
                                            : "text-muted bg-transparent"
                                            }`}
                                    >
                                        {s.label}
                                    </button>
                                ))}
                            </div>
                        </aside>

                        {/* Contenido principal */}
                        <main className="flex-grow-1 px-3" style={{
                        }}>

                            {/* Objetivo */}
                            <section id="objetivo" className="mb-2">
                                <SectionTitle icon={<Info />} title="Objetivo" />
                                <p className="text-muted small mb-1">
                                    Establecer los lineamientos para el uso adecuado del servicio de soporte técnico,
                                    garantizando una atención organizada, oportuna y trazable para todas las IPS clientes.
                                </p>
                                <div className="row g-2">
                                    {[
                                        "Optimizar los tiempos de respuesta",
                                        "Evitar duplicidad de solicitudes",
                                        "Priorizar incidentes según impacto operativo",
                                        "Garantizar la continuidad operativa de las IPS",
                                    ].map((item, i) => (
                                        <div key={i} className="col-12 col-sm-6">
                                            <div className="d-flex align-items-center gap-2 p-2 rounded bg-light border">
                                                <CheckCircle2 className="text-primary flex-shrink-0" style={{ width: 16, height: 16 }} />
                                                <span className="small">{item}</span>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </section>
                            {/* Aceptación */}
                            <section id="aceptacion" className="mb-4">
                                <SectionTitle icon={<FileCheck />} title="Aceptación de la Política" />
                                <div className="rounded border p-3" style={{ backgroundColor: "rgba(13,110,253,0.05)" }}>
                                    <p className="small mb-0">El uso del servicio implica la aceptación de esta política.</p>
                                </div>
                            </section>


                            {/* Canales Oficiales */}
                            <section id="canales" className="mb-2">
                                <SectionTitle icon={<MessageCircle />} title="Canales Oficiales de Soporte" />
                                <div className="row g-2 mb-2">
                                    {[{ href: "https://wa.me/573213294679", number: "321 329 4679" }, { href: "https://wa.me/573118248853", number: "311 824 8853" }].map((w, i) => (
                                        <div key={i} className="col-12 col-sm-6">
                                            <a href={w.href} target="_blank" rel="noopener noreferrer"
                                                className="d-flex align-items-center gap-3 p-3 rounded  text-decoration-none"
                                                style={{ border: "2px solid #25D366", backgroundColor: "rgba(13,110,253,0.05)" }}>
                                                <MessageCircle style={{ width: 24, height: 24, color: "#25D366" }} />
                                                <div>
                                                    <p className="small text-muted mb-0 opacity-75">WhatsApp</p>
                                                    <p className="fw-bold mb-0" style={{color:"#25D366"}}>{w.number}</p>
                                                </div>
                                            </a>
                                        </div>
                                    ))}
                                </div>
                                <div className="rounded border p-3">
                                    <p className="small fw-semibold mb-2">Uso correcto de canales</p>
                                    <p className="small text-muted mb-2">Cada incidente debe reportarse por <strong>un solo canal</strong>.</p>
                                    <div className="row g-2">
                                        <div className="col-12 col-md-6">
                                            <p className="small fw-bold text-danger mb-2 d-flex align-items-center gap-1">
                                                <XCircle style={{ width: 14, height: 14 }} /> No se debe
                                            </p>
                                            <ul className="list-unstyled mb-0">
                                                {[
                                                    "Reportar el mismo caso a varios números",
                                                    "Reportar por WhatsApp y llamada simultáneamente",
                                                    "Abrir múltiples conversaciones para un mismo incidente",
                                                ].map((t, i) => (
                                                    <li key={i} className="d-flex align-items-start gap-1 small text-muted mb-1">
                                                        <XCircle className="text-danger flex-shrink-0 mt-1" style={{ width: 12, height: 12 }} />{t}
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                        <div className="col-12 col-md-6">
                                            <div className="p-2 rounded bg-light small text-muted">
                                                <Info style={{ width: 14, height: 14 }} className="text-primary me-1" />
                                                Si se detecta duplicidad, el caso será gestionado por un solo canal.
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>

                            {/* Horario */}
                            <section id="horario" className="mb-2">
                                <SectionTitle icon={<Clock />} title="Horario de Atención" />
                                <div className="row g-2">
                                    <div className="col-12 col-sm-6">
                                        <div className="rounded border p-3">
                                            <p className="fw-semibold small mb-2">Lunes a Viernes</p>
                                            <div className="d-flex align-items-center gap-2 p-2 rounded bg-light mb-1">
                                                <Clock className="text-primary" style={{ width: 16, height: 16 }} />
                                                <span className="small fw-semibold">08:00 AM – 12:00 PM</span>
                                            </div>
                                            <div className="d-flex align-items-center gap-2 p-2 rounded bg-light">
                                                <Clock className="text-primary" style={{ width: 16, height: 16 }} />
                                                <span className="small fw-semibold">02:00 PM – 05:00 PM</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <div className="rounded border border-danger p-3" style={{ backgroundColor: "rgba(220,53,69,0.05)" }}>
                                            <p className="small fw-semibold mb-2 d-flex align-items-center gap-1">
                                                <AlertTriangle className="text-danger" style={{ width: 16, height: 16 }} /> Fuera de horario solo <strong>incidentes críticos</strong>
                                            </p>
                                            <ul className="list-unstyled small text-muted mb-0">
                                                <li><span className="text-danger fw-bold">•</span> Atención directa de pacientes</li>
                                                <li><span className="text-danger fw-bold">•</span> Facturación total de la IPS</li>
                                                <li><span className="text-danger fw-bold">•</span> Caída total del sistema</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </section>

                            {/* Prioridades */}
                            <section id="prioridades" className="mb-2">
                                <SectionTitle icon={<AlertTriangle />} title="Clasificación de Prioridades" />
                                <div className="row g-2">
                                    {[
                                        { color: "hsl(7 90% 46%)", emoji: "🔴", level: "Crítica", examples: ["Sistema completamente caído", "No permite atender pacientes", "No permite facturar en absoluto"] },
                                        { color: "hsl(30 100% 50%)", emoji: "🟠", level: "Alta", examples: ["Fallo en módulo principal", "Error que bloquea procesos importantes"] },
                                        { color: "hsl(46 100% 57%)", emoji: "🟡", level: "Media", examples: ["Fallos parciales", "Lentitud", "Errores intermitentes"] },
                                        { color: "hsl(214 100% 50%)", emoji: "🔵", level: "Baja", examples: ["Consultas funcionales", "Solicitudes de capacitación", "Configuraciones menores"] },
                                    ].map((p, i) => (
                                        <div key={i} className="col-12 col-sm-6">
                                            <PriorityCard {...p} />
                                        </div>
                                    ))}
                                </div>
                            </section>

                            {/* Tiempos */}
                            <section id="tiempos" className="mb-2">
                                <SectionTitle icon={<Clock />} title="Tiempos de Respuesta" />
                                <div className="rounded border p-3">
                                    <div className="d-flex align-items-start gap-2 p-2 rounded mb-3 small" style={{ backgroundColor: "rgba(13,110,253,0.05)", border: "1px solid rgba(13,110,253,0.2)" }}>
                                        <Info className="text-primary flex-shrink-0 mt-1" style={{ width: 16, height: 16 }} />
                                        <span>WhatsApp es canal de <strong>recepción</strong>, no garantiza respuesta inmediata.</span>
                                    </div>
                                    <p className="small text-muted mb-2">Las solicitudes se atienden según:</p>
                                    <div className="row g-2">
                                        {[{ num: "1", text: "Orden de llegada" }, { num: "2", text: "Prioridad del incidente" }, { num: "3", text: "Impacto operativo" }].map((item) => (
                                            <div key={item.num} className="col-12 col-sm-4">
                                                <div className="d-flex align-items-center gap-2 p-2 rounded bg-light">
                                                    <span className="d-flex align-items-center justify-content-center rounded-circle bg-primary text-white small fw-bold flex-shrink-0" style={{ width: 26, height: 26 }}>
                                                        {item.num}
                                                    </span>
                                                    <span className="small">{item.text}</span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </section>

                            {/* Información Requerida */}
                            <section id="informacion" className="mb-2">
                                <SectionTitle icon={<FileCheck />} title="Información Mínima Requerida" />
                                <div className="rounded p-3" style={{ border: "2px solid rgba(13,110,253,0.3)", backgroundColor: "rgba(13,110,253,0.05)" }}>
                                    <p className="small text-muted mb-2">Toda solicitud debe incluir:</p>
                                    <div className="row g-2">
                                        {["Nombre de la IPS", "Nombre del usuario y cargo", "Módulo afectado", "Descripción clara del problema", "Imagen o evidencia (si aplica)", "Hora aproximada del incidente"].map((item, i) => (
                                            <div key={i} className="col-12 col-sm-6">
                                                <div className="d-flex align-items-center gap-2 p-2 rounded bg-white border">
                                                    <span className="d-flex align-items-center justify-content-center rounded-circle bg-primary text-white small fw-bold flex-shrink-0" style={{ width: 20, height: 20, fontSize: 11 }}>
                                                        {i + 1}
                                                    </span>
                                                    <span className="small">{item}</span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    <div className="mt-2 p-2 rounded d-flex align-items-start gap-2 small" style={{ backgroundColor: "rgba(220,53,69,0.1)", border: "1px solid rgba(220,53,69,0.2)" }}>
                                        <AlertTriangle className="text-danger flex-shrink-0 mt-1" style={{ width: 14, height: 14 }} />
                                        <span className="text-muted">Sin información mínima pueden presentarse <strong>demoras</strong>.</span>
                                    </div>
                                </div>
                            </section>

                            {/* Uso Responsable */}
                            <section id="uso-responsable" className="mb-2">
                                <SectionTitle icon={<Shield />} title="Uso Responsable del Servicio" />
                                <div className="row g-2">
                                    <div className="col-12 col-md-6">
                                        <div className="rounded p-3 h-100" style={{ border: "2px solid rgba(220,53,69,0.2)" }}>
                                            <p className="small fw-semibold text-danger mb-2 d-flex align-items-center gap-1">
                                                <XCircle style={{ width: 16, height: 16 }} /> No está permitido
                                            </p>
                                            <ul className="list-unstyled mb-0">
                                                {["Reportar el mismo caso por múltiples canales", "Enviar múltiples mensajes para presionar respuesta", "Llamar inmediatamente después de escribir"].map((t, i) => (
                                                    <li key={i} className="d-flex align-items-start gap-1 small text-muted mb-1">
                                                        <XCircle className="text-danger flex-shrink-0 mt-1" style={{ width: 12, height: 12 }} />{t}
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div className="rounded p-3 h-100" style={{ border: "2px solid rgba(25,135,84,0.2)" }}>
                                            <p className="small fw-semibold text-success mb-2 d-flex align-items-center gap-1">
                                                <CheckCircle2 style={{ width: 16, height: 16 }} /> Está permitido
                                            </p>
                                            <ul className="list-unstyled mb-0">
                                                {["Agregar información adicional al caso reportado", "Solicitar estado del caso en tiempos razonables"].map((t, i) => (
                                                    <li key={i} className="d-flex align-items-start gap-1 small text-muted mb-1">
                                                        <CheckCircle2 className="text-success flex-shrink-0 mt-1" style={{ width: 12, height: 12 }} />{t}
                                                    </li>
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </section>

                            {/* Escalamiento */}
                            <section id="escalamiento" className="mb-2">
                                <SectionTitle icon={<ArrowUpCircle />} title="Escalamiento" />
                                <div className="rounded border p-3">
                                    <p className="small text-muted mb-2">Un caso puede escalarse cuando:</p>
                                    {["Se supera el tiempo de primera respuesta definido", "El impacto del incidente aumenta"].map((t, i) => (
                                        <div key={i} className="d-flex align-items-center gap-2 p-2 rounded bg-light mb-2">
                                            <ArrowUpCircle className="text-primary flex-shrink-0" style={{ width: 16, height: 16 }} />
                                            <span className="small">{t}</span>
                                        </div>
                                    ))}
                                </div>
                            </section>

                            {/* Compromiso */}
                            <section id="compromiso" className="mb-4">
                                <SectionTitle icon={<Handshake />} title="Compromiso del Proveedor" />
                                <div className="rounded border p-3">
                                    <p className="small text-muted mb-2">El equipo de soporte se compromete a:</p>
                                    {["Atender solicitudes dentro de los tiempos establecidos", "Mantener comunicación clara durante la gestión", "Priorizar incidentes críticos que afecten la operación clínica"].map((t, i) => (
                                        <div key={i} className="d-flex align-items-center gap-2 p-2 rounded bg-light mb-2">
                                            <CheckCircle2 className="text-primary flex-shrink-0" style={{ width: 16, height: 16 }} />
                                            <span className="small">{t}</span>
                                        </div>
                                    ))}
                                </div>
                            </section>

                        </main>
                    </div>
                </div>
            </div>


            <Footer />

            <ToastContainer />
        </>
    );
    function SectionTitle({ icon, title }: { icon: React.ReactNode; title: string }) {
        return (
            <div className="flex items-center gap-3 mb-2">
                <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-primary/10 text-primary">
                    {icon}
                </div>
                <h2 className="text-xl md:text-2xl fw-bold text-foreground">{title}</h2>
            </div>
        );
    }
    function ContactCard({
        icon,
        label,
        numbers,
        color,
    }: {
        icon: React.ReactNode;
        label: string;
        numbers: string[];
        color: string;
    }) {
        return (
            <div className="rounded-xl border border-border p-6 bg-card">
                <div className={`inline-flex items-center justify-center w-14 h-14 rounded-xl ${color} text-white mb-4`}>
                    {icon}
                </div>
                <h4 className="font-semibold text-foreground mb-2">{label}</h4>
                {numbers.map((n, i) => (
                    <p key={i} className="text-lg font-bold text-foreground">
                        {n}
                    </p>
                ))}
            </div>
        );
    }

    function PriorityCard({
        color,
        emoji,
        level,
        examples,
    }: {
        color: string;
        emoji: string;
        level: string;
        examples: string[];
    }) {
        return (
            <div
                className="rounded-xl border border-border bg-card overflow-hidden h-full flex flex-col"
                style={{ borderTopWidth: "4px", borderTopColor: color }}
            >
                <div className="p-3">
                    <h4 className="font-bold text-foreground mb-3 flex items-center gap-2">
                        <span className="text-xl">{emoji}</span> Prioridad {level}
                    </h4>
                    <ul className="space-y-1">
                        {examples.map((e, i) => (
                            <li key={i} className="text-sm text-muted-foreground flex items-start gap-2">
                                <span style={{ color }} className="font-bold mt-0.5">•</span>
                                {e}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        );
    }
};
